export interface UserSession {
  userInfo: UserInfo;
  needsForcePassword: boolean;
  urls: Urls;
  isacUser: boolean;
  icssUser: boolean;
  trissUser?: boolean;
  eseal?: boolean;
  automatic: boolean;
  migrated: boolean;
  /**serve a gestire la migrazione a myTriss */
  migrationStatus: Migration;
}

interface Urls {
  suspendCert: string;
  dikeMobileIOS: string;
  dikeMobileAndroid: string;
}

export interface UserInfo {
  username: string;
  description: string;
  codCliente: string;
  codAccount: string;
  profiles: string[];
  connectionToken: string;
  identity?: string;
 // migratable:boolean;
}

export interface IProfile {
  img: string;
  lang: string;
}
export enum HttpHeaderEnum {
  X_REQUESTED_BY = 'X-Requested-By',
  X_CSRF_TOKEN = 'X-CSRFToken',
}

export enum Migration {
  /**disponibile, non ancora avviata*/
  AVAILABLE = 'AVAILABLE',
  /**accettato le clausole e basta*/
  ACCEPTED = 'ACCEPTED',
  /**non disponibile (valore default in caso mancasse l'attributo)*/
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  /**da fare recovery (perchè forse relm è andato male)*/
  TO_FINALIZE = 'TO_FINALIZE',
}

export default UserSession;
